import React, { useEffect, useMemo, useRef, useState } from 'react'
import { Form, Switch, Button, Select } from 'antd';
import {
  SDrawerOrModal,
} from 'shj-components'
import RulesModal from "@/pages/baseProduct/components/RuleModal/RulesModal.tsx";
import {useSetState} from "ahooks";

const ExtraEditModal = ({
  openModal = false,
  onClose = () => ({}),
  editId = '',
  editData = {},
  setEditData = (val) => ({}),
  companyList = [],
  chooseType = '',
  basicInfo = {},
}) => {
  const [ form ] = Form.useForm();
  const [submitLoading, setSubmitLoading] = useState(false);
  const [ruleModal, setRuleModal] = useSetState({
    open: false,
    mode: 'modal',
    budgetQuantityRule: '',
    changeLevelScope: '',
    key: '',
    type: ''
  })

  useEffect(() => {
    setRuleModal({ budgetQuantityRule: '',budgetQuantityRule:'' })
    let budgetQuantityRule = '';
    let changeLevelScope = '';
    try {
      budgetQuantityRule = basicInfo?.budgetQuantityRule ? JSON.parse(basicInfo?.budgetQuantityRule)?.rule : '';
      changeLevelScope = basicInfo?.changeLevelScope ? JSON.parse(basicInfo?.changeLevelScope)?.rule : '';
    } catch (err) {
      console.log(err);
    }
    const info: any = {
      budgetQuantityRule: budgetQuantityRule,
      changeLevelScope: changeLevelScope,
      isCopy: basicInfo?.isCopy,
      isShowOrder: basicInfo?.isShowOrder,
      isSubtract: basicInfo?.isSubtract,
      allowUpdateBudgetQuantity: basicInfo?.allowUpdateBudgetQuantity,
    }
    if (chooseType === 'PRD_PRODUCT') {
      info.standardFlag = basicInfo?.standardFlag
    }
    if (editData?.shopId) {
      form.setFieldsValue({ ...editData })
      budgetQuantityRule = editData?.budgetQuantityRule ? JSON.parse(editData?.budgetQuantityRule)?.rule : '';
      changeLevelScope = editData?.changeLevelScope ? JSON.parse(editData?.changeLevelScope)?.rule : '';
      setRuleModal({
        ...ruleModal,
        budgetQuantityRule,
        changeLevelScope
      })
    } else {
      form.setFieldsValue({ ...info })
      setRuleModal({
        ...ruleModal,
        budgetQuantityRule:info?.budgetQuantityRule||"",
        changeLevelScope:info?.changeLevelScope||"",
      })
    }
  }, [editData, basicInfo])

  const setRule = (modalInfo = {}) => {
    setRuleModal({...ruleModal, ...modalInfo });
  }

  const handleSave = () => {
    form.validateFields().then((value: any) => {
      // 新增
      if (!editId) {
        // 要根据适用门店多选的拆开来
        if (value?.shopIds?.length) {
          const dataList = value.shopIds.map((id: string) => ({
            ...value,
            changeLevelScope: ruleModal?.changeLevelScope ? JSON.stringify({ rule: ruleModal?.changeLevelScope||"" }) : '',
            budgetQuantityRule: ruleModal?.budgetQuantityRule ? JSON.stringify({ rule: ruleModal?.budgetQuantityRule }) : '',
            shopId: id,
            shopName: companyList.find((item: any) => item.id === id)?.name
          }))
          setEditData(dataList)
        }
      } else {
        // 编辑没有门店
        setEditData([{
          ...editData,
          ...value,
          changeLevelScope: ruleModal?.changeLevelScope ? JSON.stringify({ rule: ruleModal?.changeLevelScope||"" }) : '',
          budgetQuantityRule: ruleModal?.budgetQuantityRule ? JSON.stringify({ rule: ruleModal?.budgetQuantityRule }) : '',
        }])
      }
      onClose()
    })
  }

  const MyRule = ({type,formKey}) => {
    return (
    <div>
      <Button onClick={() => setRule({ open: true, type, mode: 'modal',key:formKey })}>编辑规则</Button>
    </div>
  )};

  return (
    <>
      <div>
        <SDrawerOrModal
          width={600}
          antdProps={{ footer: [
            <Button onClick={onClose}>取消</Button>,
            <Button type={'primary'} onClick={handleSave}>保存</Button>
          ] }}
          title={editId ? '编辑' : '新增'}
          onCancel={onClose}
          loading={submitLoading}
          open={openModal}
          mode='modal'
        >
          <Form
            form={form}
            labelCol={{
              span: 12,
            }}
            layout="vertical"
            name="basicInfo"
          >
            {
              chooseType === 'PRD_PRODUCT' ? (
                <Form.Item
                  name="isSubtract"
                  label="是否可減项"
                >
                  <Switch
                    checkedChildren="是"
                    unCheckedChildren="否"
                  />
                </Form.Item>
              ) : null
            }
            <Form.Item
              name="isCopy"
              label="是否允许复制"
            >
              <Switch
                checkedChildren="是"
                unCheckedChildren="否"
              />
            </Form.Item>
            <Form.Item
              name="isShowOrder"
              label="下单是否显示"
            >
              <Switch
                checkedChildren="是"
                unCheckedChildren="否"
              />
            </Form.Item>
            {
              chooseType === 'PRD_GEN_ITEM' ? (
                  <>
                    <Form.Item
                        name="changeLevelScope"
                        label={"升降级范围"}
                        extra={ruleModal?.changeLevelScope ? `值：${ruleModal?.changeLevelScope}` : ''}
                    >
                      <>
                        <MyRule type={'productFilterRule'} formKey={'changeLevelScope'}/>
                      </>
                    </Form.Item>
                  </>
              ) : null
            }
            <Form.Item
                name="budgetQuantityRule"
                label={"预算量"}
                extra={ruleModal?.budgetQuantityRule ? `值：${ruleModal?.budgetQuantityRule}` : ''}
            >
              <>
                <MyRule type={'generalBudgetItem'} formKey={'budgetQuantityRule'} />
              </>
            </Form.Item>
            {
              chooseType === 'PRD_PRODUCT' ? (
                <>

                  <Form.Item
                      name="allowUpdateBudgetQuantity"
                      label="预算量是否可编辑"
                  >
                    <Switch
                        checkedChildren="是"
                        unCheckedChildren="否"
                    />
                  </Form.Item>
                </>
              ) : null
            }
            {
              chooseType === 'PRD_PRODUCT' ? (
                <Form.Item
                  name="standardFlag"
                  label="是否标配"
                >
                  <Switch
                    checkedChildren="是"
                    unCheckedChildren="否"
                  />
                </Form.Item>
              ) : null
            }
            {
              !editId ? (
                <Form.Item
                  label="适用门店"
                  name="shopIds"
                  rules={[{ required: true, message: '请选择适用门店' }]}
                >
                  <Select
                    mode={'multiple'}
                    optionFilterProp={'name'}
                    placeholder={'请选择适用门店'}
                    fieldNames={{ label: 'name', value: 'id' }}
                    options={[...companyList]}
                  />
                </Form.Item>
              ) : null
            }
          </Form>
        </SDrawerOrModal>
        { ruleModal.open && <RulesModal
            modalProps={{ ...ruleModal, value: ruleModal[ruleModal?.key] || '' }}
            onCancel={() => setRuleModal({ open: false })}
            type={ruleModal.type}
            onOk={(value: string) => setRuleModal({ [ruleModal?.key]: value })}
        />}
      </div>
    </>
  )
}

export default ExtraEditModal
